import { outter_post_newUrl, outter_post, post } from 'common/js/axios-helper';
import { InstitutionList,activity,instituActivity,brokenActivity,brokenActivityNew } from "./constant/UrlMapper";

const host = '8885';
const host2 = '8883';
const host3 = '8880';
const host4 = '8889';
// 添加列表
const addInstitution = (data) => {
    return post(InstitutionList.addList, data, host2);
}
// 查询列表
const signList = (data) => {
    return post(InstitutionList.stitutionList, data, host2);
}
// 修改列表
const editInstitution = (data) => {
    return post(InstitutionList.editStitution, data, host2)
}
// 修改状态
const editStatus = (data) => {
    return post(InstitutionList.disable, data, host2)
}
const moneyDetail = (data) => {
    return post(InstitutionList.moneyDetail, data, host2)
}
// ----------------------------------------------------------------------------活动页面
const signActivityList = (data) => {
    return post(activity.activityList, data, host2)
}
const addList = (data) => {
    return post(activity.addList, data, host2)
}
const editList = (data) => {
    return post(activity.editList, data, host2)
}
const deleteList = (data) => {
    return post(activity.deleteList, data, host2)
}
const udpStatus = (data) => {
    return post(activity.udpStatus, data, host2)
}
const editDaili = (data) => {
    return post(activity.editDaili, data, host2)
}
// ---------------------------------------------------------------------机构活动
const activityList = (data) => {
    return post(instituActivity.activityList, data, host2)
}
const addActivity = (data) => {
    return post(instituActivity.addActivity, data, host2)
}
const deleteActivity = (data) => {
    return post(instituActivity.deleteList, data, host2)
}
const detailList = (data) => {
    return post(instituActivity.detailList, data, host2)
}
//---------------------------------------------------------------------------------
const brokenList =  (data) => {
    return post(brokenActivity.activityList, data, host2)
}
const brokenListNew =  (data) => {
    return post(brokenActivityNew.activityList, data, host2)
}
// 鼓励金列表
const moneyList =  (data) => {
    return post(InstitutionList.moneyList, data, host)
}
// 机构提现----------
const moneyWithAdd =  (data) => {
    return post(InstitutionList.moneyWithAdd, data, host)
}
const moneyWithList =  (data) => {
    return post(InstitutionList.moneySearch, data, host)
}
const moneyAgree =  (data) => {
    return post(InstitutionList.moneyAgree, data, host)
}
const moneyUnAgree =  (data) => {
    return post(InstitutionList.moneyUnAgree, data, host)
}
export default {
    addInstitution,
    signList,
    editInstitution,
    editStatus,
    signActivityList,
    addList,
    editList,
    deleteList,
    udpStatus,
    activityList,
    addActivity,
    deleteActivity,
    detailList,
    brokenList,
    moneyList,
    moneyWithAdd,
    moneyWithList,
    moneyAgree,
    moneyUnAgree,
    moneyDetail,
    brokenListNew,
    editDaili
}



// WEBPACK FOOTER //
// ./src/service/Ainstitution.js